// extracted by mini-css-extract-plugin
export default {"newsItem":"index_newsItem_og71-","imgWp":"index_imgWp_fxy-B","textPart":"index_textPart_wDs-R","title":"index_title_w6ARy","date":"index_date_sViUp"};